import { Component } from '@angular/core';
import { LegacyTooltipPosition as TooltipPosition } from '@angular/material/legacy-tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'lum-sales-order-order-id-cell-renderer',
  templateUrl: './sales-order-order-id-cell-renderer.component.html',
  styleUrls: ['./sales-order-order-id-cell-renderer.component.scss'],
})
export class SalesOrderOrderIdCellRendererComponent
  implements ICellRendererAngularComp
{
  private params :any;
  orderId :number;
  hasFlaggedTag :boolean;
  icon = 'alert-information-circle';
  color = '#f24f63';
  tooltip = 'Tagged as FLAGGED';
  position :TooltipPosition = 'above';
  tooltipClass = 'picklist-packing-tooltip__floating';
  offset = '0,10';

  agInit(params :any) :void {
    this.params = params;
    this.orderId = this.params.value;
    this.hasFlaggedTag = this.params.data?.hasFlaggedTag;
  }

  refresh(params :ICellRendererParams<any, any, any>) :boolean {
    return true;
  }
}
